import { FormItemTypes } from '@bimser/core';
import DataGrid2 from '..';

export function setDefaultProperties(this: DataGrid2) {
	this.controlType = FormItemTypes.EControlTypes.DataGrid;

	this.caption.position = 'top';
	this.virtualScrolling = false;
	this.exportToExcel = false;
	this.gridBorder = true;
	this.hoverStateEnabled = false;
	this.showClearAllButton = false;
	this.columns = [];
	this.rows = [];
	this.dataSource = {
		name: null,
		runAtServer: false,
		parameters: []
	};
	this.dataSourceType = 'dynamic';
	this.gridLines = 'horizontal';
	this.columnSettings = {
		orderable: false,
		resizeable: false,
		showColumnChooser: false,
		resizingMode: null
	};
	this.editing = {
		enabled: false,
		showAddCommand: false,
		showDeleteCommand: false,
		showEditCommand: false,
		mode: 'row'
	};
	this.filtering = {
		enabled: false,
		showOperationChooser: false,
		headerFilterEnabled: false
	};
	this.paging = {
		enabled: true,
		currentPage: 1,
		pageSize: 10,
		pagingSizes: [10, 20, 30, 40]
	};
	this.searching = {
		enabled: false
	};
	this.selection = {
		enabled: false,
		mode: 'single',
		selectAllMode: 'page',
		showSelectAll: false,
		showCheckBoxesMode: 'onClick',
		disabledValueColumnName: '',
		disabledValueMatchers: []
	};
	this.sorting = {
		enabled: false,
		allSortingColumns: true,
		mode: 'none'
	};
	this.alternateColor = {
		color: 'rgba(33, 150, 243, 0.05)',
		enabled: true
	};
	this.toolbarActionButtons = [];
	this.hiddenRowColumnName = null;
	this.hiddenRowValueMatchers = {
		editType: 'textBox',
		values: []
	};
	this.displayType = 'AutoGrow';
	this.columnAutoWidth = true;
	this.wordWrapEnabled = false;
	this.columnHidingEnabled = false;
	this.columnFixingEnabled = false;
	this.rowDragging = {
		enabled: false,
		showDragIcons: false
	};
	this.saveMode = 'form';
	this.cacheSettingsEnabled = false;
	this.selectedRowKeys = [];
	this.selectedRowsData = [];
}
